export default __webpack_public_path__ + "static/media/headphones.a2aa1da9.svg";